module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"email":"E-mail","confirmar":"Confirmar","cancelar_recuperar_senha":"Lembrei a senha","msg_informe_seu_email":"Informe o seu e-mail e clique em confirmar para receber o link de recuperação da senha.","msg_enviou_link_recuperacao_email":"Enviamos um link com a recuperação da sua senha para o e-mail: {email}","tooltips":{"email":"Informe o seu e-mail."}}}')
  delete Component.options._Ctor
}
